import PropTypes from 'prop-types';
import {isNil} from 'ramda';
import React, {Component} from 'react';
import {withRouter} from 'react-router';
import {loadActivities, updateActivityType} from '../../api';

class StressProfile extends Component {
  constructor() {
    super();
    
    this.state = {
      people: 0,
      money: 0,
      personal: 0,
      clock: 0,
      health: 0
    };
  }
  
  componentDidMount() {
    return loadActivities()
      .then(response => {
        const stress = response.data.find(a => a.activity_type === 'stress');
        if (isNil(stress)) {
          return;
        }
        
        const pv = name => isNil(stress.properties.find(p => p.property_key === name)) ?
          0 :
          stress.properties.find(p => p.property_key === name).property_value;
        this.setState({
          people: pv('people'),
          money: pv('money'),
          personal: pv('personal'),
          clock: pv('clock'),
          health: pv('health')
        });
      });
  }
  
  buildRequestBody = () => {
    const {people, money, personal, clock, health} = this.state;
    return {
      activity: {
        properties: [{
          property_key: 'people',
          property_value: people
        }, {
          property_key: 'money',
          property_value: money
        }, {
          property_key: 'personal',
          property_value: personal
        }, {
          property_key: 'clock',
          property_value: clock
        }, {
          property_key: 'health',
          property_value: health
        }]
      }
    };
  };
  
  updateStressActivity = () => updateActivityType('stress', this.buildRequestBody())
    .then(response => {
      this.setState({
        [response.data.activity_type]: response.data.properties[0].property_value
      });
    });
  
  onNext = (nextRoute) => {
    const {router} = this.props;
    return this.updateStressActivity()
      .then(() => router.push(nextRoute));
  };
  
  onChange = (type) => (value) => {
    this.setState({[type]: value});
  };
  
  render() {
    const {children, router} = this.props;
    const {people, money, personal, clock, health} = this.state;
    
    if (!children) {
      router.push('/dashboard');
      return null;
    }
    
    return React.cloneElement(children, {
      people: people,
      money: money,
      personal: personal,
      clock: clock,
      health: health,
      onChange: this.onChange,
      onNext: this.onNext
    });
  }
}

StressProfile.propTypes = {
  children: PropTypes.any,
  router: PropTypes.any.isRequired
};

export default withRouter(StressProfile);



// WEBPACK FOOTER //
// ./src/pages/Stress/StressProfile.js